module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_3.ba330311.jpg";